import { Box, Stack, Typography } from "@mui/material"
import { UploadIllustration } from "minimals-template/assets"

export function DocumentUploadZone({ header = "Select an image" }) {
    return (
        <Stack spacing={2} alignItems="center" justifyContent="center" sx={{ width: 1, textAlign: "center" }}>
            <UploadIllustration sx={{ width: 220 }} />
            <Box sx={{ p: 3, pb: 0.5 }}>
                <Typography gutterBottom variant="h5">
                    {header}
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    <>
                        Drop file here or click&nbsp;
                        <Typography
                            variant="body2"
                            component="span"
                            sx={{ color: "primary.main", textDecoration: "underline" }}
                        >
                            browse <br />
                        </Typography>
                        &nbsp;to select from your device
                    </>
                </Typography>
            </Box>
        </Stack>
    )
}
